export const availableLocales = ['fr', 'es', 'de', 'it', 'en'];
export const supportedWrittenLocales = [
  'ar',
  'bn',
  'bg',
  'my',
  'ca',
  'zh-Hant',
  'zh-Hans',
  'zh-Hant-HK',
  'hr',
  'cs',
  'da',
  'nl',
  'en',
  'et',
  'fi',
  'fr',
  'fr-FR',
  'fr-CA',
  'de',
  'el',
  'he',
  'hi',
  'hu',
  'is',
  'id',
  'ga',
  'it',
  'ja',
  'ko',
  'lv',
  'lt',
  'ms-Latn',
  'mr',
  'nn',
  'ps',
  'fa',
  'pl',
  'pt',
  'pt-PT',
  'pt-BR',
  'pa',
  'ro',
  'ru',
  'sr-Latn',
  'sr-Cyrl',
  'sk',
  'sl',
  'es',
  'es-ES',
  'es-AR',
  'es-CL',
  'es-MX',
  'sw',
  'sv',
  'ta',
  'th',
  'tr',
  'uk',
  'ur',
  'vi',
];

export const supportedLocales = [...supportedWrittenLocales, 'zh', 'sr'];

export const countryLocales: Record<string, string[]> = {
  BA: ['hr', 'sr-Latn', 'sr-Cyrl', 'en'],
  CM: ['en', 'fr'],
  RW: ['en', 'fr'],
  SZ: ['en'],
  Latn: ['sr', 'ms'],
  IL: ['he', 'ar', 'en'],
  Arab: ['ms', 'pa'],
  PN: ['en'],
  NF: ['en'],
  TZ: ['sw', 'en'],
  TW: ['zh-Hant'],
  LI: ['de'],
  TH: ['th'],
  IN: ['ta', 'ur', 'hi', 'mr', 'bn', 'en', 'pa'],
  EA: ['es'],
  GF: ['fr'],
  TR: ['tr', 'en'],
  CH: ['de', 'fr', 'en', 'it'],
  TG: ['fr'],
  NG: ['en'],
  SC: ['fr', 'en'],
  HN: ['es'],
  AG: ['en'],
  KZ: ['ru'],
  ET: [],
  MO: ['zh-Hant', 'en', 'pt', 'zh-Hans'],
  BE: ['de', 'fr', 'nl', 'en'],
  KH: [],
  MM: ['my'],
  MZ: ['pt'],
  GH: ['en'],
  EC: ['es'],
  GB: ['en'],
  ME: ['en', 'sr-Latn', 'sr-Cyrl'],
  MK: [],
  MR: ['ar', 'fr'],
  BM: ['en'],
  AI: ['en'],
  ES: ['es', 'ca', 'en'],
  PR: ['es', 'en'],
  ML: ['fr'],
  MG: ['en', 'fr'],
  TL: ['pt'],
  LC: ['en'],
  SG: ['ta', 'ms-Latn', 'zh-Hans', 'en'],
  LV: ['lv', 'en'],
  US: ['en', 'es'],
  PT: ['en', 'pt', 'pt-PT'],
  LR: ['en'],
  NL: ['en', 'nl'],
  CA: ['en', 'fr', 'fr-CA'],
  UG: ['en', 'sw'],
  MH: ['en'],
  TO: ['en'],
  ZA: ['en'],
  MA: ['fr', 'ar'],
  KM: ['ar', 'fr'],
  AL: ['en'],
  BJ: ['fr'],
  VU: ['fr', 'en'],
  DE: ['de', 'en'],
  CD: ['sw', 'fr'],
  RE: ['fr'],
  KE: ['en', 'sw'],
  GL: ['da'],
  TN: ['fr', 'ar'],
  PA: ['es'],
  PL: ['pl', 'en'],
  NE: ['fr'],
  GQ: ['es', 'fr'],
  GN: ['fr'],
  PW: ['en'],
  NO: ['en', 'nn'],
  RS: ['sr-Latn', 'sr-Cyrl'],
  FR: ['fr'],
  Guru: ['pa'],
  ZW: ['en'],
  BO: ['es'],
  AF: ['ps', 'fa'],
  BS: ['en'],
  CX: ['en'],
  ZM: ['en'],
  HT: ['fr'],
  GP: ['fr'],
  GR: ['el', 'en'],
  CY: ['en', 'tr', 'el'],
  GT: ['es'],
  HK: ['zh-Hant', 'zh-Hans', 'zh-Hant-HK', 'en'],
  UY: ['es'],
  NR: ['en'],
  PE: ['es'],
  SN: ['fr'],
  CZ: ['en', 'cs'],
  JO: ['ar'],
  CF: ['fr'],
  TD: ['ar', 'fr'],
  BW: ['en'],
  AS: ['en'],
  BN: ['ms-Latn', 'ms'],
  CN: ['zh-Hans'],
  AM: [],
  CG: ['fr'],
  MP: ['en'],
  SA: ['ar'],
  FI: ['fi', 'en', 'sv'],
  LY: ['ar'],
  AT: ['en', 'de'],
  NA: ['en'],
  NU: ['en'],
  PH: ['es', 'en'],
  KI: ['en'],
  JE: ['en'],
  AU: ['en'],
  IR: ['fa'],
  UZ: [],
  PF: ['fr'],
  IT: ['it', 'ca', 'en'],
  BZ: ['en'],
  KW: ['ar'],
  GW: ['pt'],
  VC: ['en'],
  DJ: ['fr', 'ar'],
  SV: ['es'],
  MS: ['en'],
  ST: ['pt'],
  SD: ['ar', 'en'],
  IQ: ['ar'],
  MT: ['en'],
  GE: [],
  SR: ['nl'],
  DO: ['es'],
  MU: ['en', 'fr'],
  EE: ['et', 'en'],
  IE: ['en', 'ga'],
  CL: ['es', 'es-CL'],
  CV: ['pt'],
  CI: ['fr'],
  NZ: ['en'],
  KG: ['ru'],
  KN: ['en'],
  SJ: [],
  RU: ['ru', 'en'],
  AX: ['sv'],
  VG: ['en'],
  BF: ['fr'],
  MW: ['en'],
  LS: ['en'],
  NC: ['fr'],
  IS: ['is', 'en'],
  FO: [],
  LT: ['en', 'lt'],
  QA: ['ar'],
  CO: ['es'],
  AZ: [],
  BI: ['fr'],
  VI: ['en'],
  MY: ['en', 'ms-Latn', 'ms', 'ta'],
  LU: ['en', 'de', 'fr'],
  SY: ['fr', 'ar'],
  JM: ['en'],
  PM: ['fr'],
  MD: ['ru', 'ro'],
  IM: ['en'],
  NI: ['es'],
  SX: ['nl', 'en'],
  TC: ['en'],
  EG: ['ar'],
  MC: ['fr'],
  CR: ['es'],
  EH: ['ar'],
  GD: ['en'],
  BL: ['fr'],
  SB: ['en'],
  PK: ['ur', 'pa', 'en'],
  SO: ['ar'],
  MF: ['fr'],
  WS: ['en'],
  CU: ['es'],
  JP: ['ja'],
  IO: ['en'],
  GG: ['en'],
  AO: ['pt'],
  RO: ['ro', 'en'],
  UM: ['en'],
  SE: ['en', 'sv'],
  KY: ['en'],
  GI: ['en'],
  BR: ['pt', 'pt-BR'],
  TJ: [],
  PY: ['es'],
  SS: ['ar', 'en'],
  TK: ['en'],
  LK: ['ta'],
  DZ: ['fr', 'ar'],
  AD: ['ca', 'en'],
  AR: ['es', 'es-AR'],
  SK: ['sk', 'en'],
  SH: ['en'],
  ER: ['ar', 'en'],
  BQ: ['nl'],
  SI: ['en', 'sl'],
  GM: ['en'],
  Vaii: [],
  CW: ['nl'],
  HR: ['en', 'hr'],
  FJ: ['en'],
  BY: ['ru'],
  FK: ['en'],
  SL: ['en'],
  BH: ['ar'],
  LA: [],
  NP: [],
  IC: ['es'],
  XK: ['sr-Latn', 'sr-Cyrl'],
  HU: ['hu', 'en'],
  AE: ['ar'],
  FM: ['en'],
  KP: ['ko'],
  MQ: ['fr'],
  VE: ['es'],
  WF: ['fr'],
  UA: ['ru', 'uk'],
  TM: [],
  MN: [],
  KR: ['ko'],
  DG: ['en'],
  CC: ['en'],
  SM: ['it'],
  TT: ['en'],
  OM: ['ar'],
  MX: ['es', 'es-MX'],
  GU: ['en'],
  LB: ['ar', 'fr'],
  TV: ['en'],
  AW: ['nl'],
  PS: ['ar'],
  BB: ['en'],
  PG: ['en'],
  BD: ['bn'],
  DK: ['da', 'en'],
  YT: ['fr'],
  YE: ['ar'],
  ID: ['id'],
  GY: ['en'],
  DM: ['en'],
  GA: ['fr'],
  VN: ['vi'],
  CK: ['en'],
  BG: ['bg'],
};
